throw new Error(`No exports are available from the top-level "@clerk/testing" package.
Use specific subpath imports instead, e.g. "@clerk/testing/playwright" or "@clerk/testing/cypress".

Find all available exports in the documentation:
https://clerk.com/docs/testing/overview`);
